import { createContext, ReactNode } from 'react';

import {
  useAPIFetchApplicationTypes,
  useAPIFetchProducts,
  useAPIFetchCategories,
  useAPIFetchIntendedUsers,
  useAPIFetchIntendedPurposes
} from '@marketplace/api';

type ApplicationAttributesProviderProps = {
  children: ReactNode;
};

export const ApplicationAttributesContext = createContext({});

export const ApplicationAttributesProvider = (
  props: ApplicationAttributesProviderProps
): JSX.Element => {
  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-ignore
  const { data: categories, loaded: isCategoriesLoaded, providerCategories, patientCategories } =
    useAPIFetchCategories();
  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-ignore
  const { data: solutions, loaded: isSolutionsLoaded } = useAPIFetchProducts();

  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-ignore
  const { data: appTypes, loaded: isAppTypesLoaded } =
    useAPIFetchApplicationTypes();

  const { data: intendedUsers, loaded: isIntendedUsersLoaded  } =
  useAPIFetchIntendedUsers();

  const { data: intendedPurposes, loaded: isIntendedPurposesLoaded  } =
  useAPIFetchIntendedPurposes();

  return (
    <ApplicationAttributesContext.Provider
      value={{
        categories,
        providerCategories,
        patientCategories,
        isCategoriesLoaded,
        solutions,
        isSolutionsLoaded,
        appTypes,
        isAppTypesLoaded,
        intendedUsers,
        isIntendedUsersLoaded,
        intendedPurposes,
        isIntendedPurposesLoaded
      }}
    >
      {props.children}
    </ApplicationAttributesContext.Provider>
  );
};
